var _rect, _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTickCloud(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    width: 47,
    height: 47,
    rx: 7.567,
    fill: "#541689"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.1424 34.006H33.482C33.9843 34.006 34.4579 33.8832 34.8744 33.6659C34.9106 33.647 34.948 33.6306 34.9865 33.6173C38.0243 32.5746 40.2076 29.693 40.2076 26.3015C40.2076 22.0308 36.7455 18.5687 32.4747 18.5687C32.215 18.5687 31.9582 18.5815 31.705 18.6065C31.3136 18.6452 30.9465 18.3818 30.8574 17.9987C30.0608 14.5757 26.991 12.0254 23.3256 12.0254C19.6035 12.0254 16.4956 14.6551 15.7585 18.1579C15.7083 18.3962 15.4963 18.5687 15.2529 18.5687C10.9821 18.5687 7.52002 22.0308 7.52002 26.3015C7.52002 30.5723 10.9821 34.0344 15.2529 34.0344C15.4778 34.0344 15.7005 34.0248 15.9206 34.006H31.807C32.0271 34.0248 32.2498 34.0344 32.4747 34.0344C32.6996 34.0344 32.9223 34.0248 33.1424 34.006Z",
    fill: "url(#paint0_linear_2632_4182)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.451 22.137C22.7984 21.4475 23.7826 21.4475 24.13 22.137L25.0627 23.9884C25.2722 24.4042 25.7546 24.604 26.1967 24.4581L28.1654 23.8085C28.8985 23.5666 29.5946 24.2626 29.3526 24.9957L28.703 26.9643C28.5571 27.4065 28.7568 27.8889 29.1727 28.0984L31.0241 29.0311C31.7136 29.3784 31.7136 30.3627 31.0241 30.71L29.1727 31.6428C28.7568 31.8522 28.5571 32.3346 28.703 32.7768L29.3526 34.7455C29.5946 35.4786 28.8985 36.1746 28.1654 35.9327L26.1967 35.2831C25.7546 35.1372 25.2722 35.3369 25.0627 35.7528L24.13 37.6042C23.7826 38.2937 22.7984 38.2937 22.451 37.6042L21.5183 35.7528C21.3088 35.3369 20.8265 35.1372 20.3843 35.2831L18.4156 35.9327C17.6825 36.1746 16.9865 35.4786 17.2284 34.7455L17.878 32.7768C18.0239 32.3346 17.8241 31.8522 17.4083 31.6428L15.5569 30.71C14.8674 30.3627 14.8674 29.3784 15.5569 29.0311L17.4083 28.0984C17.8241 27.8889 18.0239 27.4065 17.878 26.9643L17.2284 24.9957C16.9865 24.2626 17.6825 23.5666 18.4156 23.8085L20.3843 24.4581C20.8265 24.604 21.3088 24.4042 21.5183 23.9884L22.451 22.137Z",
    fill: "#DCB9FE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6799 30.08L22.5599 31.96L26.3199 28.2",
    stroke: "#8F48C8",
    strokeWidth: 1.6215,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2632_4182",
    x1: 19.27,
    y1: 5.63989,
    x2: 14.8694,
    y2: 33.0581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C070FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C117C"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickCloud);
export default __webpack_public_path__ + "static/media/tickCloud.90e2dcf2a7e58a4c8da7586d8e5de6ff.svg";
export { ForwardRef as ReactComponent };